import { heroImage, statItems, tickerItems } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
        <img
          src={heroImage}
          alt="美丽的小蜜桃写真视频资源聚合首页主视觉"
          title="美丽的小蜜桃写真视频资源合集"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/40 to-transparent" />

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
          <span className="inline-flex items-center gap-2 bg-white/12 border border-white/25 text-white text-xs md:text-sm px-4 py-1.5 rounded-full backdrop-blur mb-6">
            <i className="ri-sparkling-2-line text-accent-300" />
            个人写真 · 视频资源 · 套图大全 一站式聚合
          </span>

          <h1 className="font-heading font-black text-white text-3xl md:text-[56px] leading-tight tracking-tight max-w-4xl">
            美丽的小蜜桃写真视频合集
          </h1>

          <p className="mt-5 text-white/85 text-sm md:text-lg leading-relaxed max-w-2xl">
            个人写真与视频资源集中地，收录高清套图、私拍福利与精选美图。
            无论想收藏她的写真合集，还是寻找视频资源与套图大全，都能在这里找到顺畅的观赏入口。
          </p>

          <div className="mt-8 w-full flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#gallery"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium h-12 px-7 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-gallery-line text-lg" />
              浏览精选套图
            </a>
            <a
              href="#videos"
              className="inline-flex items-center justify-center gap-2 bg-white/12 hover:bg-white/20 border border-white/30 text-white text-sm md:text-base font-medium h-12 px-7 rounded-full transition-colors whitespace-nowrap cursor-pointer backdrop-blur"
            >
              <i className="ri-play-circle-line text-lg" />
              进入视频资源
            </a>
          </div>
        </div>
      </div>

      <div className="w-full bg-background-100/80 backdrop-blur border-b border-background-200/70">
        <div className="w-full px-4 md:px-8 py-4 flex items-center gap-4">
          <span className="hidden sm:inline-flex items-center gap-1.5 shrink-0 text-primary-600 text-sm font-medium">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" />
            资源快讯
          </span>
          <span className="hidden sm:block w-px h-5 bg-background-300" />
          <div className="relative overflow-hidden flex-1">
            <div className="flex w-max animate-marquee">
              {[...tickerItems, ...tickerItems].map((item, idx) => (
                <span
                  key={idx}
                  className="text-sm text-foreground-700 whitespace-nowrap pr-10"
                >
                  <i className="ri-flashlight-line text-accent-600 mr-1.5" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 -mt-10 md:-mt-12 relative z-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {statItems.map((stat) => (
            <div
              key={stat.id}
              className="bg-background-50 rounded-lg border border-background-200/80 px-4 md:px-5 py-5 flex items-center gap-3.5"
            >
              <span className="w-11 h-11 md:w-12 md:h-12 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <span className="flex flex-col">
                <span className="font-heading font-bold text-foreground-950 text-lg md:text-2xl leading-none">
                  {stat.value}
                </span>
                <span className="text-xs md:text-sm text-foreground-500 mt-1.5">
                  {stat.label}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}